import Alert from '@risk-smart/themed-cloudscape-components/alert';
import Button from '@risksmart-app/components/src/button';
import { Component, type ReactNode } from 'react';
import { type WithTranslation, withTranslation } from 'react-i18next';

type Props = WithTranslation & {
  children: ReactNode;
  onOpenSettings?: () => void;
};

type State = {
  hasError: boolean;
};

class WidgetContentErrorBoundaryInner extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    const { t, children, onOpenSettings } = this.props;

    if (this.state.hasError) {
      return (
        <div className={'flex flex-col items-center gap-2 p-4'}>
          <Alert type={'warning'}>{t('widget.content_error_fallback')}</Alert>
          {onOpenSettings && (
            <Button onClick={onOpenSettings}>
              {t('widget.error_edit_settings')}
            </Button>
          )}
        </div>
      );
    }

    return children;
  }
}

export const WidgetContentErrorBoundary = withTranslation(['common'])(
  WidgetContentErrorBoundaryInner
);
